// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"595":"f6b3679e","737":"f6b3679e"}[chunkId] + ".chunk.css";
};